// Types shared between the UI and the storage layer.

export type EmailDest = "roke" | "carto";
export type NoteStatus = "pending" | "sent" | "error";

// Notes are immutable: state transitions produce new copies, never mutate.
export interface Note {
  readonly id: string;
  readonly text: string;
  readonly timestamp: number;
  readonly dest: EmailDest;
  readonly status: NoteStatus;
  readonly errorMessage: string | null;
}

// Label shown on a carto bubble (none for roke, the default).
export const DEST_LABEL: Record<EmailDest, string | null> = {
  roke: null,
  carto: "carto",
};
